import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#1D7ED9",
            light: "#66B2F2",
            dark: "#0F4373",
            contrastText: "#FFFFFF",
        },
        secondary: {
            main: "#0B3154",
            light: "#175A9C",
            contrastText: "#FFFFFF",
        },
        background: {
            default: "#F8FAFC",
            paper: "#FFFFFF",
            dark: "#05111D",
            section: "#0B1726",
        },
        text: {
            primary: "#111827",
            secondary: "#4B5563",
            muted: "#B2B5B9",
            inverse: "#FFFFFF",
        },
        border: {
            main: "#E5E7EB",
            accent: "#1D7ED9",
        },
    },
    typography: {
        fontFamily: '"Montserrat", "Roboto", "Arial", sans-serif',
        h1: {
            fontFamily: '"Montserrat", "Roboto", "Arial", sans-serif',
            fontWeight: 700,
            fontSize: "3.5rem",
            lineHeight: 1.1,
        },
        h2: {
            fontFamily: '"Montserrat", "Roboto", "Arial", sans-serif',
            fontWeight: 700,
            fontSize: "2.75rem",
            lineHeight: 1.2,
        },
        h3: {
            fontFamily: '"Montserrat", "Roboto", "Arial", sans-serif',
            fontWeight: 600,
            fontSize: "2rem",
            lineHeight: 1.25,
        },
        h4: {
            fontWeight: 600,
            fontSize: "1.5rem",
            lineHeight: 1.3,
        },
        h5: {
            fontWeight: 600,
            fontSize: "1.25rem",
            lineHeight: 1.4,
        },
        h6: {
            fontWeight: 600,
            fontSize: "1rem",
            lineHeight: 1.5,
        },
        body1: {
            fontSize: "1rem",
            lineHeight: 1.7,
            fontWeight: 400,
        },
        body2: {
            fontSize: "0.95rem",
            lineHeight: 1.6,
            fontWeight: 400,
        },
        button: {
            fontWeight: 600,
            textTransform: "none",
        },
    },
    shape: {
        borderRadius: 16,
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: "#F8FAFC",
                    color: "#111827",
                    fontFamily: '"Montserrat", "Roboto", "Arial", sans-serif',
                },
                a: {
                    color: "inherit",
                    textDecoration: "none",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 999,
                    padding: "12px 24px",
                    boxShadow: "none",
                    textTransform: "none",
                    "&:hover": {
                        boxShadow: "none",
                    },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 20,
                    boxShadow: "0px 10px 30px rgba(11, 49, 84, 0.08)",
                },
            },
        },
    },
});

export default theme;
